import PropTypes from 'prop-types';
import { FormGroup, Label, PasswordField as UIPasswordField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './PasswordField.module.scss';

const PasswordField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.passwordIdField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.passwordId}>
          {credentialForm.passwordLabel}
        </Label>
        <UIPasswordField
          id={credentialForm.passwordId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
          autoComplete="new-password"
        />
      </FormGroup>
    </div>
  );
};

PasswordField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

PasswordField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default PasswordField;
